import { Breadcrumb } from "@/components/admin";
import { Card, CardContent } from "@/components/ui/card";
import { EditBase, Form, useEditContext } from "ra-core";
import { Link } from "react-router";

import type { Contact } from "../types";
import { ContactAside } from "./ContactAside";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";

export const ContactEdit = () => (
  <EditBase redirect="show">
    <ContactEditContent />
  </EditBase>
);

const ContactEditContent = () => {
  const { isPending, record } = useEditContext<Contact>();
  if (isPending || !record) return null;
  return (
    <div className="mt-2 flex flex-col gap-4 w-full">
      <Breadcrumb>
        <Breadcrumb.Item><Link to="/contacts">Leads</Link></Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/contacts/${record.id}/show`}>
            {`${record.first_name || ''} ${record.last_name || ''}`.trim() || record.title}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.PageItem>Edit</Breadcrumb.PageItem>
      </Breadcrumb>

      <div className="flex gap-8">
        <Form className="flex flex-1 flex-col gap-4">
          <Card>
            <CardContent>
              <ContactInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>

        <ContactAside link="edit" />
      </div>
    </div>
  );
};
